import React, { useEffect, useState } from "react";
import { sum } from "lodash";
import {
    InfoText,
    ModalWrapper,
    TitleText,
    TitleWrapper,
    ButtonRow,
    Expandable,
    StyledBackdrop,
} from "./Styled";
import { api } from "../../../../../../shared/hooks/api";
import CustomTable from "../../../../../../shared/components/CustomTable";
import { ExtraFee, ProductExtraFee } from "../../../../../../data/entities";
import SearchBarWithSuggestion from "../../../../../../shared/components/SearchBar/SearchBarWithSuggestion";

import { StyledButton } from "../../../../../../shared/styled/TitleBar";
import { formatCurrency } from "../../../../../../utils/format";
import { ExtraFeeRow, ExtraFeeTableColumns } from "..";
import { Modal } from "@mui/material";

interface AddExtraFeesModalProps {
    selectedExtraFees: ProductExtraFee[];
    open: boolean;
    handleClose: any;
    mergeProduct: Function;
    category?: string;
}

export const AddExtraFeesModal = ({
    selectedExtraFees,
    open,
    handleClose,
    mergeProduct,
    category,
}: AddExtraFeesModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    
    // Add category to API request if it exists
    const queryParams = category 
        ? `?is_active=true&page_size=${Number.MAX_SAFE_INTEGER}&category=${category}`
        : `?is_active=true&page_size=${Number.MAX_SAFE_INTEGER}`;
        
    const [{ data, variables, error }, fetchExtraFees] = api.get(
        `/extrafees${queryParams}`,
        undefined,
        true
    );
    const [selectedItems, setSelectedItems] =
        useState<ProductExtraFee[]>(selectedExtraFees);

    const extraFees = data && data.results ? data.results : [];

    const summaryExtraFees = {
        id: `Tổng chi phí kèm theo`,
        price: formatCurrency(
            sum(
                selectedItems.map(
                    (item: ProductExtraFee) =>
                        item.extra_fee.price * item.quantity
                )
            )
        ),
        isSummary: true,
    };

    const tableItems =
        selectedItems.length === 0
            ? []
            : [...selectedItems, summaryExtraFees].map((item, idx) => ({
                  ...item,
              }));

    const removeSelectedItem = (item: ProductExtraFee) => {
        const removedSelectedItems = selectedItems.filter(
            (selectedItem, idx) =>
                selectedItem.extra_fee.id !== item.extra_fee.id
        );
        setSelectedItems(removedSelectedItems);
    };

    const updateItemSelectedQuantity = (
        updateItem: ProductExtraFee,
        selectedQuantity: number
    ) => {
        const updatedSelectedItems = selectedItems.map((item) => {
            if (item.extra_fee.id === updateItem.extra_fee.id) {
                return { ...item, quantity: selectedQuantity };
            }
            return item;
        });
        setSelectedItems(updatedSelectedItems);
    };

    const handleOnclickItem = (item: ExtraFee, isAdded: boolean) => {
        if (isAdded) {
            setSelectedItems([
                ...selectedItems,
                { extra_fee: item, quantity: 0 } as ProductExtraFee,
            ]);
        } else {
            const updatedSelectedItems = selectedItems.filter(
                (selectedItem) => selectedItem.extra_fee.id !== item.id
            );
            setSelectedItems(updatedSelectedItems);
        }
    };

    const onClickAddExtraFees = () => {
        mergeProduct({ extra_fees: selectedItems });
        handleClose();
    };

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={isOpen}>
                <Expandable>
                    <TitleWrapper>
                        <TitleText>Thêm chi phí kèm theo</TitleText>
                        <InfoText>Vui lòng lựa chọn chi phí kèm theo{category ? ` cùng danh mục ${category}` : ""}</InfoText>
                    </TitleWrapper>

                    <SearchBarWithSuggestion
                        selectedItems={selectedItems.map((item) => ({
                            name: item.extra_fee.name,
                        }))}
                        menuList={extraFees}
                        fetchItems={(variables: any) => {
                            // Add category filter if it exists
                            const params = category 
                                ? { ...variables, category }
                                : variables;
                            return fetchExtraFees(params);
                        }}
                        handleOnclickItem={handleOnclickItem}
                    />

                    <CustomTable
                        itemList={tableItems}
                        RowElement={ExtraFeeRow}
                        TableColumns={ExtraFeeTableColumns}
                        extraRowProps={{
                            removeItem: removeSelectedItem,
                            updateItemSelectedQuantity,
                        }}
                        containerStyle={{ maxHeight: "400px" }}
                    />
                </Expandable>

                <ButtonRow>
                    <StyledButton onClick={handleCloseWithAnimation}>
                        Huỷ bỏ
                    </StyledButton>
                    <StyledButton
                        variant="contained"
                        onClick={onClickAddExtraFees}
                    >
                        Lưu chi phí
                    </StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};
